<template>
  <div>
    <div class="loading" v-if="showLoading">
      <van-loading type="spinner" />数据加载中...
    </div>
    <div v-for="(model, index) in list" :key="index" class="list-box">
      <!---------------------- 刚出生和满月------------------------------->
      <div v-if="!model.type || model.type <= 1">
        <div>
          <div class="info-title">0~6岁儿童眼保健及视力检查记录表</div>
          <div class="info-title">新生儿期</div>
          <div class="info">
            <span>姓名：{{ model.childrenName }}</span>
            <span>性别：{{ model.sex ? '女' : '男' }}</span>
            <span>出生日期：{{ model.birthday }}</span>
          </div>
          <table class="base-table" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td colspan="3" class="zd-title">项目</td>
              <td class="zd-title">{{ model.tableName + '档案' }}</td>
            </tr>
            <tr>
              <td rowspan="14" style="width: 30px;">
                <div>眼病筛查及视力评估</div>
              </td>
              <td colspan="2" style="width: 2rem;">总体情况</td>
              <td class="nocenter">
                <div class="input-info">
                  <span class="sel-span">{{ model.situation }}</span>
                  <label v-for="(item, index) in ycType" :key="index">
                    {{ item.value }} {{ item.txt }}
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td rowspan="6">眼外观</td>
              <td style="width: 1rem;">1 眼睑</td>
              <td class="nocenter">
                <span v-for="(item, index) in yjType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼: <input class="other"
                      v-model="model.rightMovemenElse">
                    <br>左眼: <input class="other" v-model="model.leftMovemenElse" readonly></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightMovemen)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftMovemen)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>2 结膜</td>
              <td class="nocenter">
                <span v-for="(item, index) in jmType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightJunctiElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftJunctiElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightJuncti)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftJuncti)'></label>
                </div>
              </td>
            </tr>

            <tr>
              <td>3 眼球</td>
              <td class="nocenter">
                <span v-for="(item, index) in yqType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightMovemBallElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftMovemBallElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightMovemBall)'></label>
                  <span style="margin: 0 0.15rem"></span><br />
                  左眼 <label v-html='dataFormat(model.leftMovemBall)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>4 角膜</td>
              <td class="nocenter">
                <span v-for="(item, index) in jiaomoType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightEyeCornElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftEyeCornElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyeCorn)'></label>
                  <span style="margin: 0 0.15rem"></span><br />
                  左眼 <label v-html='dataFormat(model.leftEyeCorn)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>5 瞳孔</td>
              <td class="nocenter">
                <span v-for="(item, index) in tongkongType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightEyePupElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftEyePupElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyePup)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftEyePup)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>6 巩膜</td>
              <td class="nocenter">
                <span v-for="(item, index) in gongmoType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightEyeScleraElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftEyeScleraElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyeSclera)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftEyeSclera)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td rowspan="6">主要眼病高危因素</td>
              <td>1 出生时早产或低出生体重</td>
              <td class="nocenter">
                <span v-for="(item, index) in zaochanType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.birthStateElse"></label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.birthState)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>2 曾入住新生儿重症监护病房</td>
              <td class="nocenter">
                <span v-for="(item, index) in zhongzhengType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.newbornRoomElse"></label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.newbornRoom)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>3 遗传性眼病家族史</td>
              <td class="nocenter">
                <span v-for="(item, index) in yichaunType" :key="index">
                  <label v-if="item.txt !== '其他'">
                    <br v-if="item.value === 2">{{ item.value }} {{ item.txt }}
                    <input class="other" v-if="item.value === 1" readonly v-model="model.illnessRecordName1">
                    <input class="other" v-if="item.value === 2" readonly v-model="model.illnessRecordName2"
                      style="width: 150px;">
                  </label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.illnessRecordElse"></label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.illnessRecord)'></label>
                </div>
              </td>

            </tr>
            <tr>
              <td>4 母亲孕期宫内感染</td>
              <td class="nocenter">
                <span v-for="(item, index) in gongneiType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.infectionElse"></label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.infection)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>5 颅面及颜面畸形</td>
              <td class="nocenter">
                <span v-for="(item, index) in yanmianType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.mutantElse"></label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.mutant)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>6 眼部情况</td>
              <td class="nocenter">
                <span v-for="(item, index) in yanbuType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.eyeStateElse"></label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.eyeState)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>其他检查</td>
              <td>光照反应</td>
              <td class="nocenter" v-if="model.type == 0">/</td>
              <td class="nocenter" v-if="model.type != 0">
                <span v-for="(item, index) in guangzhaoType" :key="index">
                  {{ item.value }} {{ item.txt }}
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightLightReaction)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftLightReaction)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3">转诊建议</td>
              <td class="nocenter">
                <div class="zd-title">转诊原因：</div>
                <div v-if="model.type == 0">
                  <div v-for="(item, index) in changeSuggestXS" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse"></label>
                  </div>
                </div>
                <div v-if="model.type == 1">
                  <div v-for="(item, index) in changeSuggestMy" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse"></label>
                  </div>
                </div>
                <div class="input-info">
                  <label v-html='dataFormat(model.changeSuggest)'></label>
                  <br>机构： <input v-model="model.suggestHospital" class="other" readonly>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="3">健康指导</td>
              <td class="nocenter">
                <div class="zd-title">普遍性指导</div>
                <div>1 新生儿视力发育需要良好的环境亮度，白天要保证室内光线明亮，夜间睡眠时应关灯。</div>
                <div>2 日常养育照护注意保持眼部清洁卫生。</div>
                <div>3 保证新生儿充足睡眠和营养。</div>
                <div>4 从出生就要有近视防控意识。</div>
                <div>5 定期带新生儿做眼保健。</div>
                <div>6 告知家长注意观察新生儿眼病有无异常，若发现异常及时就医。</div>
                <div class="zd-title">针对性指导</div>
                <div>1 出生体重＜2000g的低出生体重儿和出生孕周＜32周的早产儿未按要求进行眼底检查者，告知家长应在生后4～6周或矫正胎龄32周，由眼科医师进行首次眼底病变筛查。</div>
                <div>2 其他眼病相关危险因素，告知家长新生儿应尽早接受进一步眼科检查。</div>
                <div>3 其他指导 <input class="other" v-model="model.healthSuggestElse" readonly>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3">检查日期</td>
              <td class="nocenter">
                <label v-html='model.checkDate'></label>
              </td>
            </tr>
            <tr>
              <td colspan="3">医生签名</td>
              <td class="nocenter"><input v-model="model.doctorName" class="other" readonly>
              </td>
            </tr>
            <tr>
              <td colspan="3">医疗机构名称</td>
              <td class="nocenter"><input v-model="model.hospitalName" class="other" readonly>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!---------------------- 3月到12月------------------------------->
      <div v-if="model.type >= 3 && model.type <= 12" class="page-break">
        <div>
          <div class="info-title">0~6岁儿童眼保健及视力检查记录表</div>
          <div class="info-title">婴儿期（1岁以内）</div>
          <div class="info">
            <span>姓名：{{ model.childrenName }}</span>
            <span>性别：{{ model.sex ? '女' : '男' }}</span>
            <span>出生日期：{{ model.birthday ? model.birthday.substring(0, 10) : '' }}</span>
          </div>
          <table class="base-table" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td colspan="3" class="zd-title">项目</td>
              <td style="width: 500px;" class="zd-title">{{ model.tableName + '档案' }}</td>
            </tr>
            <tr>
              <td rowspan="11" style="width: 30px;">眼病筛查及视力评估</td>
              <td colspan="2">总体情况</td>
              <td class="nocenter">
                <div class="input-info">
                  <span class="sel-span">{{ model.situation }}</span>
                  <label v-for="(item, index) in ycType" :key="index">
                    {{ item.value }} {{ item.txt }}
                  </label>
                </div>
              </td>
            </tr>

            <tr>
              <td rowspan="4">眼外观</td>
              <td>1 眼球</td>
              <td class="nocenter">
                <span v-for="(item, index) in yqType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightMovemBallElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftMovemBallElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightMovemBall)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftMovemBall)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>2 结膜</td>
              <td class="nocenter">
                <span v-for="(item, index) in jmType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightJunctiElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftJunctiElse"></label>
                </span>

                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightJuncti)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftJuncti)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>3 角膜</td>
              <td class="nocenter">

                <span v-for="(item, index) in jiaomoType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightEyeCornElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftEyeCornElse"></label>
                </span>

                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyeCorn)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftEyeCorn)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>4 瞳孔</td>
              <td class="nocenter">

                <span v-for="(item, index) in tongkongType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightEyePupElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftEyePupElse"></label>
                </span>

                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyePup)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftEyePup)'></label>
                </div>

              </td>
            </tr>
            <tr>
              <td rowspan="6">其他检查</td>
              <td>1 瞬目反射</td>
              <td class="nocenter" v-if="model.type !== 3">/</td>
              <td class="nocenter" v-if="model.type === 3">
                <span v-for="(item, index) in shunmuType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.blinkTp)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>2 红球试验</td>
              <td class="nocenter" v-if="model.type !== 3">/</td>
              <td class="nocenter" v-if="model.type === 3">
                <span v-for="(item, index) in hongqiuType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.redBallTp)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>3 视物行为观察</td>
              <td class="nocenter">
                <span v-for="(item, index) in shiwuType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.vbobstio)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>*4 红光反射</td>
              <td class="nocenter" v-if="model.type != 6">/</td>
              <td class="nocenter" v-if="model.type == 6">
                <span v-for="(item, index) in hongguangType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                </span>

                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightRedliTp)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftRedliTp)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>*5 眼位检查</td>
              <td class="nocenter" v-if="model.type != 6">/</td>
              <td class="nocenter" v-if="model.type == 6">
                <span v-for="(item, index) in yanweiType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.levelTpElse"></label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.levelTp)'></label>
                </div>

              </td>
            </tr>
            <tr>
              <td>*6 单眼遮盖厌恶试验</td>
              <td class="nocenter" v-if="model.type != 6">/</td>
              <td class="nocenter" v-if="model.type == 6">
                <span v-for="(item, index) in danyanType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyeClose)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftClose)'></label>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="3">转诊建议</td>
              <td class="nocenter">
                <div class="zd-title">转诊原因：</div>
                <div v-if="model.type == 3">
                  <div v-for="(item, index) in changeSuggest3" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse">
                    </label>
                  </div>
                </div>
                <div v-if="model.type == 6">
                  <div v-for="(item, index) in changeSuggest6" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse"></label>
                  </div>
                </div>
                <div v-if="model.type == 8">
                  <div v-for="(item, index) in changeSuggest8" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse"></label>
                  </div>
                </div>
                <div v-if="model.type == 12">
                  <div v-for="(item, index) in changeSuggest12" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse"></label>
                  </div>
                </div>
                <div class="input-info">
                  <label v-html='dataFormat(model.changeSuggest)'></label>
                  <br>机构： <input v-model="model.suggestHospital" class="other" readonly>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="3">健康指导</td>
              <td class="nocenter">
                <div class="zd-title">普遍性指导</div>
                <div>1 婴儿视力发育需要良好的环境亮度，白天要保证室内光线明亮，夜间睡眠时应关灯。</div>
                <div>2 日常养育照护中注意保持婴儿眼部清洁卫生。</div>
                <div>3 保持婴儿充足睡眠和营养。</div>
                <div>4 婴儿应避免强光直射，建议婴儿禁用手机、电脑等视屏类电子产品。</div>
                <div>5 告知远视储备量的知识。</div>
                <div>6 指导家长树立婴儿近视防控意识。</div>
                <div>7 告知家长注意观察婴儿眼病有无异常，若发现异常及时就医。</div>
                <div class="zd-title">针对性指导</div>
                <div>1 若儿童存在眼病相关危险因素，告知家长到眼科检查。</div>
                <div v-if="model.type != 6">
                  <div>2 其他指导<input class="other" v-model="model.healthSuggestElse" readonly>
                  </div>
                </div>
                <div v-if="model.type == 6">
                  <div>2 告知家长带婴儿到县级妇幼保健机构或具备条件的县级医疗机构做红光反射、眼位检查、单眼遮盖厌恶试验。</div>
                  <div>3 其他指导<input class="other" v-model="model.healthSuggestElse" readonly>
                  </div>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="3">检查日期</td>
              <td class="nocenter">
                <span>{{ model.checkDate }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="3">医生签名</td>
              <td class="nocenter"><input v-model="model.doctorName" class="other" readonly>
              </td>
            </tr>
            <tr>
              <td colspan="3">医疗机构名称</td>
              <td class="nocenter"><input v-model="model.hospitalName" class="other" readonly>
              </td>
            </tr>
          </table>
          <div>注：标记“*”的服务项目主要由县级妇幼保健机构或具备条件的县级医疗机构开展，鼓励有条件的乡镇卫生院、社区卫生服务中心开展这些服务项目。</div>
        </div>
      </div>
      <!---------------------- 1岁到3岁------------------------------->
      <div v-if="model.type > 12 && model.type <= 36" class="page-break">
        <div>
          <div class="info-title">0~6岁儿童眼保健及视力检查记录表</div>
          <div class="info-title">幼儿期（1～3岁）</div>
          <div class="info">
            <span>姓名：{{ model.childrenName }}</span>
            <span>性别：{{ model.sex ? '女' : '男' }}</span>
            <span>出生日期：{{ model.birthday ? model.birthday.substring(0, 10) : '' }}</span>
          </div>
          <table class="base-table" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td colspan="3" class="zd-title">项目</td>
              <td style="width: 500px;" class="zd-title">{{ model.tableName + '档案' }}</td>
            </tr>

            <tr>
              <td rowspan="10" style="width: 30px;">眼病筛查及视力评估</td>
              <td colspan="2">总体情况</td>
              <td class="nocenter">
                <div class="input-info">
                  <span class="sel-span">{{ model.situation }}</span>
                  <label v-for="(item, index) in ycType" :key="index">
                    {{ item.value }} {{ item.txt }}
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td rowspan="5">眼外观</td>
              <td>1 眼睑</td>
              <td class="nocenter">
                <span v-for="(item, index) in yjType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼: <input class="other"
                      v-model="model.rightMovemenElse"> <br>左眼: <input class="other" v-model="model.leftMovemenElse"
                      readonly></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightMovemen)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftMovemen)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>2 眼球</td>
              <td class="nocenter">
                <span v-for="(item, index) in yqType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightMovemBallElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftMovemBallElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightMovemBall)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftMovemBall)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>3 结膜</td>
              <td class="nocenter">
                <span v-for="(item, index) in jmType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightJunctiElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftJunctiElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightJuncti)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftJuncti)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>4 角膜</td>
              <td class="nocenter">

                <span v-for="(item, index) in jiaomoType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightEyeCornElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftEyeCornElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyeCorn)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftEyeCorn)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>5 瞳孔</td>
              <td class="nocenter"><span v-for="(item, index) in tongkongType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightEyePupElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftEyePupElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyePup)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftEyePup)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td rowspan="4">其他检查</td>

              <td>1 视物行为观察</td>
              <td class="nocenter">
                <span v-for="(item, index) in shiwuType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.vbobstio)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>*2 眼位检查</td>
              <td class="nocenter" v-if="model.type == 18 || model.type == 30">/</td>
              <td class="nocenter" v-if="model.type != 18 && model.type != 30">
                <span v-for="(item, index) in yanweiType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.levelTpElse"></label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.levelTp)'></label>
                </div>

              </td>
            </tr>
            <tr>
              <td>*3 单眼遮盖厌恶试验</td>
              <td class="nocenter" v-if="model.type == 18 || model.type == 30">/</td>
              <td class="nocenter" v-if="model.type != 18 && model.type != 30">
                <span v-for="(item, index) in danyanType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyeClose)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftEyeClose)'></label>
                </div>

              </td>
            </tr>
            <tr>
              <td>*4 屈光筛查</td>
              <td class="nocenter" v-if="model.type == 18 || model.type == 30">/</td>
              <td class="nocenter" v-if="model.type != 18 && model.type != 30">
                <div><span style="margin-right: 20px;">右眼</span> 球镜 <input class="other-sc" v-model="model.avgRightBall"
                    readonly>
                  柱镜 <input class="other-sc" v-model="model.avgRightSyl" readonly>
                  轴位 <input class="other-sc" v-model="model.avgRightAxial" readonly>
                </div>
                <div><span style="margin-right: 20px;">左眼</span> 球镜 <input class="other-sc" v-model="model.avgLeftBall"
                    readonly>
                  柱镜 <input class="other-sc" v-model="model.avgLeftSyl" readonly>
                  轴位 <input class="other-sc" v-model="model.avgLeftAxial" readonly>
                </div>
                <div>（非散瞳验光结果仅供参考）</div>
                <span v-for="(item, index) in quguangType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} 右眼:<input class="other" readonly
                      v-model="model.rightDioCheckElse">左眼:<input class="other" readonly
                      v-model="model.leftDioCheckElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightDioCheck)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftDioCheck)'></label>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="3">转诊建议</td>
              <td class="nocenter">
                <div class="zd-title">转诊原因：</div>
                <div v-if="model.type == 18">
                  <div v-for="(item, index) in changeSuggest18" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse"></label>
                  </div>
                </div>

                <div v-if="model.type == 24">
                  <div v-for="(item, index) in changeSuggest24" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse"></label>
                  </div>
                </div>

                <div v-if="model.type == 30">
                  <div v-for="(item, index) in changeSuggest30" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse"></label>
                  </div>
                </div>

                <div v-if="model.type == 30">
                  <div v-for="(item, index) in changeSuggest36" :key="index">
                    <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                    <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                        v-model="model.changeSuggestElse"></label>
                  </div>
                </div>
                <div class="input-info">
                  <label v-html='dataFormat(model.changeSuggest)'></label>
                  <br>机构： <input v-model="model.suggestHospital" class="other" readonly>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="3">健康指导</td>
              <td class="nocenter">
                <div class="zd-title">普遍性指导</div>
                <div>1 指导家长注意观察幼儿有无歪头视物、视物距离过近等行为。</div>
                <div>2 保证充足睡眠和营养。</div>
                <div>3 告知家长至少每半年带幼儿接受一次眼保健和视力检查。</div>
                <div>4 家长给幼儿阅读绘本，减少近距离用眼时间。</div>
                <div>5 建议幼儿禁用手机、电脑等视屏类电子产品。</div>
                <div>6 户外活动不少2小时/天。</div>
                <div>7 避免幼儿玩尖锐物、接触强酸强碱等洗涤剂。</div>
                <div>8 教育、帮助幼儿经常洗手，不揉眼睛，不带患传染性眼病幼儿到人群聚集场所活动。</div>
                <div>9 告知家长注意观察幼儿眼病有无异常，若发现异常及时就医。</div>
                <div class="zd-title">针对性指导</div>
                <div>1 儿童远视储备量不足，需进一步排查发生近视风险，并改变不良用眼行为，定期检查。</div>
                <div>2 若儿童存在斜视、弱视等眼病及危险因素，告知家长到眼科检查。</div>
                <div v-if="model.type != 18">
                  <div>3 告知家长带婴儿到县级妇幼保健机构或具备条件的县级医疗机构做红光反射检查、眼位检查、单眼遮盖厌恶试验。</div>
                  <div>4 其他指导<input class="other" v-model="model.healthSuggestElse" readonly>
                  </div>
                </div>
                <div v-if="model.type == 18">
                  <div>3 其他指导<input class="other" v-model="model.healthSuggestElse" readonly>
                  </div>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="3">检查日期</td>
              <td class="nocenter">
                <span>{{ model.checkDate }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="3">医生签名</td>
              <td class="nocenter"><input v-model="model.doctorName" class="other" readonly>
              </td>
            </tr>
            <tr>
              <td colspan="3">医疗机构名称</td>
              <td class="nocenter"><input v-model="model.hospitalName" class="other" readonly>
              </td>
            </tr>
          </table>
          <div>注：标记“*”的服务项目主要由县级妇幼保健机构或具备条件的县级医疗机构开展，鼓励有条件的乡镇卫生院、社区卫生服务中心开展这些服务项目。“S”为球镜数值；“C”为柱镜数值；“A”为散光轴位度数</div>
        </div>
      </div>
      <!---------------------- 4岁到6岁------------------------------->
      <div v-if="model.type > 36" class="page-break">
        <div>
          <div class="info-title">0~6岁儿童眼保健及视力检查记录表</div>
          <div class="info-title">学龄前期（4～6岁）</div>
          <div class="info">
            <span>姓名：{{ model.childrenName }}</span>
            <span>性别：{{ model.sex ? '女' : '男' }}</span>
            <span>出生日期：{{ model.birthday ? model.birthday.substring(0, 10) : '' }}</span>
          </div>
          <table class="base-table" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td colspan="3" class="zd-title">项目</td>
              <td style="width: 500px;" class="zd-title">{{ model.tableName + '档案' }}</td>
            </tr>

            <tr>
              <td rowspan="10" style="width: 30px;">眼病筛查及视力评估</td>
              <td colspan="2">总体情况</td>
              <td class="nocenter">
                <div class="input-info">
                  <span class="sel-span">{{ model.situation }}</span>
                  <label v-for="(item, index) in ycType" :key="index">
                    {{ item.value }} {{ item.txt }}
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td rowspan="5">眼外观</td>
              <td>1 眼睑</td>
              <td class="nocenter">

                <span v-for="(item, index) in yjType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼: <input class="other"
                      v-model="model.rightMovemenElse"> <br>左眼: <input class="other" v-model="model.leftMovemenElse"
                      readonly></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightMovemen)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftMovemen)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>2 眼球</td>
              <td class="nocenter">
                <span v-for="(item, index) in yqType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightMovemBallElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftMovemBallElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightMovemBall)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftMovemBall)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>3 结膜</td>
              <td class="nocenter">
                <span v-for="(item, index) in jmType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightJunctiElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftJunctiElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightJuncti)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftJuncti)'></label>
                </div>
              </td>
            </tr>

            <tr>
              <td>4 角膜</td>
              <td class="nocenter">

                <span v-for="(item, index) in jiaomoType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightEyeCornElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftEyeCornElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyeCorn)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftEyeCorn)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>5 瞳孔</td>
              <td class="nocenter"><span v-for="(item, index) in tongkongType2" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <br>右眼:<input class="other"
                      readonly v-model="model.rightEyePupElse"><br>左眼:<input class="other" readonly
                      v-model="model.leftEyePupElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightEyePup)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftEyePup)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td rowspan="4">其他检查</td>
              <td>1 视物行为观察</td>
              <td class="nocenter"><span v-for="(item, index) in shiwuType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.vbobstio)'></label>
                </div>
              </td>
            </tr>
            <tr>
              <td>*2 视力检查</td>
              <td class="nocenter">
                <div>右眼 <a-input class="other-sc" style="margin-right: 20px;" v-model="model.rightVision" /> 左眼 <a-input
                    class="other-sc" v-model="model.leftVision" />
                </div>
                <span v-for="(item, index) in slType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} 右眼:<input class="other" readonly
                      v-model="model.rightVisionCheckElse">左眼:<input class="other" readonly
                      v-model="model.leftVisionCheckElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightVisionCheck)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftVisionCheck)'></label>
                </div>

              </td>
            </tr>
            <tr>
              <td>*3 眼位检查</td>
              <td class="nocenter">
                <span v-for="(item, index) in yanweiType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.levelTpElse"></label>
                </span>
                <div class="input-info">
                  <label v-html='dataFormat(model.levelTp)'></label>
                </div>

              </td>
            </tr>

            <tr>
              <td>*4 屈光筛查</td>
              <td class="nocenter">
                <div><span style="margin-right: 20px;">右眼</span> 球镜 <input class="other-sc" v-model="model.avgRightBall">
                  柱镜 <input class="other-sc" v-model="model.avgRightSyl">
                  轴位 <input class="other-sc" v-model="model.avgRightAxial">
                </div>
                <div><span style="margin-right: 20px;">左眼</span> 球镜 <input class="other-sc" v-model="model.avgLeftBall">
                  柱镜 <input class="other-sc" v-model="model.avgLeftSyl">
                  轴位 <input class="other-sc" v-model="model.avgLeftAxial">
                </div>
                <div>（非散瞳验光结果仅供参考）</div>
                <span v-for="(item, index) in quguangType" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'"><br />{{ item.value }} {{ item.txt }} 右眼:<input class="other" readonly
                      v-model="model.rightDioCheckElse">左眼:<input class="other" readonly
                      v-model="model.leftDioCheckElse"></label>
                </span>
                <div class="input-info">
                  右眼 <label v-html='dataFormat(model.rightDioCheck)'></label>
                  <span style="margin: 0 0.15rem"></span>
                  左眼 <label v-html='dataFormat(model.leftDioCheck)'></label>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="3">转诊建议</td>
              <td class="nocenter">
                <div class="zd-title">转诊原因：</div>
                <div v-for="(item, index) in changeSuggest48" :key="index">
                  <label v-if="item.txt !== '其他'">{{ item.value }} {{ item.txt }}</label>
                  <label v-if="item.txt === '其他'">{{ item.value }} {{ item.txt }} <input class="other" readonly
                      v-model="model.changeSuggestElse"></label>
                </div>
                <div class="input-info">
                  <label v-html='dataFormat(model.changeSuggest)'></label>
                  <br>机构： <input v-model="model.suggestHospital" class="other" readonly>
                </div>

              </td>
            </tr>
            <tr>
              <td colspan="3">健康指导</td>
              <td class="nocenter">
                <div class="zd-title">普遍性指导</div>
                <div>1 告知家长至少每年带儿童进行一次眼保健和视力检查。</div>
                <div>2 培养良好用眼习惯，科学护眼和防控近视。</div>
                <div>3 避免接触和使用电子视屏类电子产品。</div>
                <div>4 减少近距离用眼时间。</div>
                <div>5 增加户外活动，每天2小时以上在室外活动“目”浴阳光。</div>
                <div>6 读写和握笔姿势正确。</div>
                <div>7 保证儿童充足睡眠和营养。</div>
                <div>8 告知家长注意观察儿童视物有无异常，一旦发现异常，要到正规医疗机构进行医学验光，并遵医嘱正确矫正。</div>
                <div class="zd-title">针对性指导</div>
                <div>1 儿童远视储备量不足。需进一步检查并改变不良用眼行为，定期检查。</div>
                <div>2 若儿童存在斜视、弱视等眼病及危险因素，告知家长到眼科检查。</div>
                <div>3 科学护眼和防控近视。</div>
                <div>4 告知家长带婴儿到县级妇幼保健机构或具备条件的县级医疗机构做眼位检查、屈光筛查。</div>
                <div>5 其他指导<input class="other" v-model="model.healthSuggestElse" readonly>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3">检查日期</td>
              <td class="nocenter">
                <span>{{ model.checkDate }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="3">医生签名</td>
              <td class="nocenter"><input v-model="model.doctorName" class="other" readonly>
              </td>
            </tr>
            <tr>
              <td colspan="3">医疗机构名称</td>
              <td class="nocenter"><input v-model="model.hospitalName" class="other" readonly>
              </td>
            </tr>
          </table>
          <div>注：标记“*”的服务项目主要由县级妇幼保健机构或具备条件的县级医疗机构开展，鼓励有条件的乡镇卫生院、社区卫生服务中心开展这些服务项目。“S”为球镜数值；“C”为柱镜数值；“A”为散光轴位度数</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'child',
  data() {
    return {
      openId: '',
      showLoading: true,
      hospitalId: '',
      list: [],
      childId: '',
      ycType: [], // 异常
      yjType: [], // 眼睑
      jmType: [], // 结膜
      yqType: [], // 眼球
      jiaomoType: [], // 角膜
      tongkongType: [], // 瞳孔
      gongmoType: [], // 巩膜
      zaochanType: [], // 早产
      zhongzhengType: [], // 重症监护室
      yichaunType: [], //遗传
      gongneiType: [], // 宫内感染
      yanmianType: [], // 颜面畸形
      yanbuType: [], // 眼部情况
      guangzhaoType: [], // 光照反应
      zhuanzhenType: [], // 转诊建议
      jiankangType: [], // 健康指导

      yqType2: [], // 眼球
      jmType2: [], // 结膜
      jiaomoType2: [], // 角膜
      tongkongType2: [], // 瞳孔
      shunmuType: [],// 瞬目反射
      hongqiuType: [],// 红球试验
      shiwuType: [], // 视物行为观察
      hongguangType: [], //红光反射
      yanweiType: [], // 眼位检查
      danyanType: [], // 单眼遮盖
      quguangType: [], // 屈光
      changeSuggestXS: [],
      changeSuggestMy: [],
      changeSuggest3: [],
      changeSuggest6: [],
      changeSuggest8: [],
      changeSuggest12: [],
      changeSuggest18: [],
      changeSuggest24: [],
      changeSuggest30: [],
      changeSuggest36: [],
      changeSuggest48: [],
      slType: [],
      childBasicsType: [],
    };
  },
  async mounted() {
    this.childId = this.$route.query.childId;
    this.hospitalId = this.$route.query.hospitalId;
    this.openId = this.$route.query.openId;
    this.getTitle();
    await this.getDictItem();
    await this.getData();
  },
  methods: {
    /**
     * 获取数据
    */
    async getData() {
      let res = await this.$http.post(`${this.$url.listLasts}?studentId=${this.childId}&hospitalId=${this.hospitalId}`, {
        chilId: this.childId,
        hospitalId: this.hospitalId
      });
      let temp = res.data.data;
      let list = temp.filter(item => item.type);
      if (list && list.length > 0) {
        list.forEach(item => {
          item.birthday = item.birthday ? item.birthday.substring(0, 10) : '';
          item.checkDate = item.checkDate ? item.checkDate.substring(0, 10) : '';
          let temp = this.childBasicsType.filter(itemTemp => itemTemp.value == item.type);

          if (temp && temp.length > 0) {
            item.tableName = temp[0].txt;
          } else {
            item.tableName = '';
          }
        });
        this.list = list;
      }
      this.showLoading = false;
    },
    sortData(a, b) {
      return a.value - b.value
    },
    async getDictItem() {
      let type = 'situation,movemenB2,junctiB2,movemBallB2,eyeCornB2,eyePupB2,eyeScleraB2,birthState,newbornRoom,illnessRecord,infection,mutant,eyeState,lightReaction,healthSuggest,movemBallQT,junctiQT,eyeCornQT,eyePupQT,blinkTp,redBalTp,vbobstio,redLiTp,levelTp,eyeClose,dioCheck,changeSuggestXS,changeSuggestMy,changeSuggest3,changeSuggest6,changeSuggest8,changeSuggest12,changeSuggest18,changeSuggest24,changeSuggest30,changeSuggest36,changeSuggest48,visionCheck,childBasicsType';
      let res = await this.$http.get(this.$url.getDictItemsBatch + '/' + type);
      let data = res.data.data;
      Object.keys(data).forEach(item => {
        let list = [];
        data[item].forEach(itemValue => {
          list.push({ label: parseInt(itemValue.value), value: parseInt(itemValue.value), txt: itemValue.title })
        });
        if (['changeSuggestXS', 'changeSuggestMy', 'changeSuggest3', 'changeSuggest6', 'changeSuggest8', 'changeSuggest12', 'changeSuggest18', 'changeSuggest24', 'changeSuggest30', 'changeSuggest36', 'changeSuggest48', 'visionCheck'].includes(item)) {
          let hasOther = 0;
          list.forEach(item => {
            if (item.txt === '其他') hasOther = 1;
          })
          if (!hasOther) list.push({ label: list.length + 1, value: list.length + 1, txt: '其他' })
        }
        data[item] = list;
      });
      this.ycType = data.situation;
      this.yjType = data.movemenB2;
      this.jmType = data.junctiB2;
      this.yqType = data.movemBallB2;
      this.jiaomoType = data.eyeCornB2;
      this.tongkongType = data.eyePupB2;
      this.gongmoType = data.eyeScleraB2;
      this.zaochanType = data.birthState;
      this.zhongzhengType = data.newbornRoom;
      this.yichaunType = data.illnessRecord;
      this.gongneiType = data.infection;
      this.yanmianType = data.mutant;
      this.yanbuType = data.eyeState;
      this.guangzhaoType = data.lightReaction;
      this.jiankangType = data.healthSuggest;
      this.yqType2 = data.movemBallQT;
      this.jmType2 = data.junctiQT;
      this.jiaomoType2 = data.eyeCornQT;
      this.tongkongType2 = data.eyePupQT;
      this.shunmuType = data.blinkTp;
      this.hongqiuType = data.redBalTp;
      this.shiwuType = data.vbobstio;
      this.hongguangType = data.redLiTp;
      this.yanweiType = data.levelTp;
      this.danyanType = data.eyeClose;
      this.quguangType = data.dioCheck;
      this.changeSuggestXS = data.changeSuggestXS;
      this.changeSuggestMy = data.changeSuggestMy;
      this.changeSuggest3 = data.changeSuggest3;
      this.changeSuggest6 = data.changeSuggest6;
      this.changeSuggest8 = data.changeSuggest8;
      this.changeSuggest12 = data.changeSuggest12;
      this.changeSuggest18 = data.changeSuggest18;
      this.changeSuggest24 = data.changeSuggest24;
      this.changeSuggest30 = data.changeSuggest30;
      this.changeSuggest36 = data.changeSuggest36;
      this.changeSuggest48 = data.changeSuggest48;
      this.slType = data.visionCheck;
      this.childBasicsType = data.childBasicsType;
    },

    async getTitle() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getTitle, {
        openId: this.openId,
        auth: auth.code,
        time: auth.time
      })
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        document.title = result.data?.title
      }
    },
    dataFormat(value) {
      let str = "";
      if (value === null || value === '' || value === 'undefined' || value === 'undefined,') str += "<span style=' padding: 1px 12px;border: 1px solid #ccc;border-radius: 2px;margin:0 10px;'></span>";
      if (value && value.length > 1) {
        value = value.split(',');
        for (let loop = 0; loop < value.length; loop++) {
          if (value[loop] != null && value[loop] != "") {
            str += "<span style=' padding: 1px 8px;border: 1px solid #ccc;border-radius: 2px;margin:0 10px;'>" + value[loop] + "</span>" + "/";
          }
        }
        str = str.substring(0, str.length - 1);
      }
      return str;
    },
  }
};
</script>
<style scope lang="less">
.list-box {
  margin-top: 0.3rem;
}

.info-title {
  margin-top: 0.2rem;
  line-height: 1.5em;
  text-align: center;
  font-size: 0.3rem;
  font-weight: bold;
}

.info {
  width: 6.9rem;
  margin: 0.2rem auto;
  text-align: left;

  span {
    display: inline-block;
    margin-right: 0.3rem;
  }
}

table {
  width: 100%;
  border-radius: 0.1rem;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;

  td {
    padding: 0.1rem;
    text-align: center;
    vertical-align: middle;
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
  }
}

.nocenter {
  margin-left: 0.1rem;
  text-align: left;
  line-height: 1.8em;

  span {
    line-height: 0.2rem;
    margin-right: 0.2rem;
  }

  .input-info {
    flex-wrap: wrap;
    width: 2rem;
    margin-top: 0.15rem;
  }

  .other-sc {
    width: 1rem;
    margin-left: 0.1rem;
    border: 0;
    outline: none;
    border-bottom: 1px solid #ccc;
  }

  .other {
    margin-left: 0.1rem;
    width: 2rem;
    border: 0;
    outline: none;
    border-bottom: 1px solid #ccc;
  }
}

.sel-span {
  padding: 1px 8px;
  border: 1px solid #ccc;
  border-radius: 2px;
}

.zd-title {
  font-weight: bold;
}
</style>
